// src/components/Spinner.js
import React from 'react';
import './style.css'; // We'll create this next

const Spinner = () => {
	return (
		<div className="spinner-container">
			<div className="spinner"></div>
		</div>
	);
}

export default Spinner;